module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', _vm._l((_vm.filteredList), function(item) {
    return _c('cell', {
      key: item.brandId,
      attrs: {
        "title": item.cname
      },
      nativeOn: {
        "click": function($event) {
          _vm.gotoPanel(item)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f54b0f8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/tvBox/IptvList.vue
// module id = 913
// module chunks = 1